<script lang="ts" setup>
import type { IAppProps } from '@/interfaces/IAppProps'
import { useHead } from '@vueuse/head'
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import { useRoute } from 'vue-router'
import { useEntryProps } from '@/composable/useDatasetProps'

const { t } = useI18n()

const { brandName } = useEntryProps<IAppProps>()

const route = useRoute()
useHead({
    title: computed(() => {
        const metaTitle = route.meta.title

        let title = ''
        if (metaTitle === undefined || metaTitle === null) {
            title = brandName
            return title
        }

        switch (metaTitle.toString().toLowerCase()) {
            case 'deposit':
                title = `${brandName} - ${t('deposit')}`
                break

            case 'withdraw':
                title = `${brandName} - ${t('withdraw')}`
                break

            case 'history':
                title = `${brandName} - ${t('history')}`
                break

            default:
                title = brandName
                break
        }

        return title
    }),
})
</script>

<template>
    <div />
</template>
